module.exports = __webpack_public_path__ + "img/sweden-neoplasm-male.b0131b42.png";